import { render, staticRenderFns } from "./VideoClipList.vue?vue&type=template&id=abeddf96&"
import script from "./VideoClipList.vue?vue&type=script&lang=ts&"
export * from "./VideoClipList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports